<div class="mega-text text-center gotham uppercase margin-bottom-1 color-black">
   EXPERIENCE STORE DJI
</div>
<div class="carosell-wrapper">
    <div [ngStyle]="{width: windowWith+'px', transform: 'translate3d(-'+carosellItemClone+'px, 0px, 0px)'}"
        class="carosell-container">

        <div style="padding: 10px;" [ngStyle]="{width: carosellItem+'px'}" class="carosell-item"
            *ngFor="let item of banners; let i=index">
            <img width="200" height="300" style="width: 100%;" [src]="item.img_url" alt="">


        </div>
    </div>
    <div class="carosell-navigation">
        <a style="
    color: white;" class="carosell-navigation-left" (click)="scrollRight()">
            <fa-icon [icon]="faChevronLeft"></fa-icon>
        </a>
        <a style=" 
    color: white;" class="carosell-navigation-right" (click)="scrollLeft()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
        </a>
    </div>

</div>